// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__yPeZu","root--sm":"Chip_root--sm__XToGD","rotation":"Chip_rotation__WwMoP"};